import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewChild } from '@angular/core';
import { SnapshotService } from '../../Services/snapshot.service';
import * as _ from 'lodash';
import { CustomsnapshotService } from '../../Services/customsnapshot.service';
import { LoaderService } from 'src/app/common/services/loader.service';
import { BarserviceService } from '../../../snapshot/custom-snapshot-chart-modules/barchart/barchart/barservice.service';
import { ChatbotService } from 'src/app/common/services/chatbot.service';
import { InsightspopupService } from 'src/app/common/services/insightspopup.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-custom-widget-output',
  templateUrl: './custom-widget-output.component.html',
  styleUrls: ['./custom-widget-output.component.css'],
})
export class CustomWidgetOutputComponent implements OnChanges, OnDestroy {
  hideCharts: boolean = false;
  insightKeys: any;
  InsightsResponse: any;
  //  isInsightspopupOpen: boolean=false;
  showSnapshot: boolean = false;
  isLoading: boolean = true;
  // insightsVal: any;

  constructor(
    public _configService: SnapshotService,
    private _configCustomService: CustomsnapshotService,
    private loader: LoaderService,
    private barService: BarserviceService,
    private apiService: ChatbotService,
    private _insightsSerive: InsightspopupService,
    private _cdr: ChangeDetectorRef
  ) {}
  @Input() outputData: any = {};
  isInsightspopupOpen: any;
  insightsVal: any;
  insightsData: any;
  @Input() sigIndex: string = '';
  @Input() isIndex: boolean = false;
  @Output() pageCounterChanged = new EventEmitter<number>();
  @Output() globalColorMapChanged = new EventEmitter<{ [key: string]: string }>();
  @ViewChild('inforRibbon', { static: false }) inforRibbon:
    | ElementRef
    | undefined;
  // colorPalette = this.barService.color1;
  colorPalette =
    this.barService.color1?.length > 0
      ? this.barService.color1
      : this.barService.commonchartmodules.color1;
  linearGradientsColorPalette = this.barService.linearGradients;
  globalColorMap: { [key: string]: string } = {};
  brandcolors =  this.barService.brandcolors?.length > 0
      ? this.barService.brandcolors
      : this.barService.commonchartmodules.brandcolors;
  filteredColorPalette: string[] = [];
  globalColorMapLinearGradient: { [key: string]: string } = {};
  globalMetricColorMap: { [key: string]: string } = {};
  globalMetricColorMapLinearGradient: { [key: string]: string } = {};
  mounted = false;
  singleInsight: any = null;
  private subscription!: Subscription;

  /**
   * Stores brandcolors values in globalColorMap format
   * Converts from brandcolors array format to { [key: string]: string } format
   */
  storeBrandColorsInGlobalColorMap(): void {
    if (this.brandcolors && Array.isArray(this.brandcolors)) {
      this.brandcolors.forEach((brand: any) => {
        if (brand.BrandName && brand.HexCode) {
          this.globalColorMap[brand.BrandName] = brand.HexCode;
        }
        console.log("Color in the globalColorMap:", this.globalColorMap);

      });
    }
    // Emit the updated globalColorMap to parent component
    this.globalColorMapChanged.emit(this.globalColorMap);
  }

  
  extractKeyAfterPipe(key: string): string {
    if (key && typeof key === 'string' && key.includes('|')) {
      const parts = key.split('|');
      return parts.length > 1 ? parts[parts.length - 1].trim() : key.trim();
    }
    return key || '';
  }

  storeMetricColorsInGlobalColorMap(items: any[]): void {
    let globalMetricColorIndex = Object.keys(this.globalColorMap).length; // Start after brand colors

    items.forEach((widget: any) => {
      if (!widget.widget_name || !widget.metric || widget.metric.length === 0) {
        return;
      }

      widget.metric.forEach((metricGroup: any) => {
        if (metricGroup.metric_value && Array.isArray(metricGroup.metric_value)) {
          metricGroup.metric_value.forEach((metricValue: any) => {
            const metricOption = metricValue.option || metricValue.metric_name;
            
            // Extract the part after pipe if it exists
            const extractedOption = this.extractKeyAfterPipe(metricOption);
            
            // Create metric color key
            let metricColorKey = extractedOption;
            if (this._configService.selectedSnapshotType === 'Single Brand' || 
                this._configService.selectedSnapshotType === 'Audience Snapshot') {
              // For single brand/audience snapshot, include rowChild info
              if (metricValue.data && metricValue.data.length > 0) {
                const rowChild = metricValue.data[0]?.rowChild || '';
                metricColorKey = `${extractedOption}__${rowChild}`;
              }
            }

            // Assign color if not already mapped in either map
            if (!this.globalMetricColorMap[metricColorKey] && !this.globalColorMap[metricColorKey]) {
              const assignedColor = this.getFilteredColor(globalMetricColorIndex);
              
              // Store in both maps - metric color map and main global color map
              this.globalMetricColorMap[metricColorKey] = assignedColor;
              this.globalColorMap[metricColorKey] = assignedColor;
              
              this.globalMetricColorMapLinearGradient[metricColorKey] =
                this.linearGradientsColorPalette[globalMetricColorIndex % this.linearGradientsColorPalette.length];
              this.globalColorMapLinearGradient[metricColorKey] =
                this.linearGradientsColorPalette[globalMetricColorIndex % this.linearGradientsColorPalette.length];
              
              globalMetricColorIndex++;
            }
          });
        }
      });
    });

    }
  assignColorsToMetricData(items: any[]): void {
    items.forEach((widget: any) => {
      if (!widget.widget_name || !widget.metric || widget.metric.length === 0) {
        return;
      }

      widget.metric.forEach((metricGroup: any) => {
        if (metricGroup.metric_value && Array.isArray(metricGroup.metric_value)) {
          metricGroup.metric_value.forEach((metricValue: any) => {
            const metricOption = metricValue.option || metricValue.metric_name;
            
            // Extract the part after pipe if it exists
            const extractedOption = this.extractKeyAfterPipe(metricOption);
            
            // Look up color from global color map using extracted key
            let assignedColor = this.globalColorMap[extractedOption];
            
            // If not found, try with special handling for different snapshot types
            if (!assignedColor && (this._configService.selectedSnapshotType === 'Single Brand' || 
                this._configService.selectedSnapshotType === 'Audience Snapshot')) {
              if (metricValue.data && metricValue.data.length > 0) {
                const rowChild = metricValue.data[0]?.rowChild || '';
                const metricColorKey = `${extractedOption}__${rowChild}`;
                assignedColor = this.globalColorMap[metricColorKey];
              }
            }
            
            // Also look in metric color map
            if (!assignedColor) {
              assignedColor = this.globalMetricColorMap[extractedOption];
            }

            // If color found, assign it to the metric and all its data entries
            if (assignedColor) {
              metricValue.metricColor = assignedColor;
              metricValue.metricLinearGradient = this.globalColorMapLinearGradient[extractedOption] || 
                                               this.globalMetricColorMapLinearGradient[extractedOption];
              
              // Also assign to all data entries within this metric
              if (metricValue.data && Array.isArray(metricValue.data)) {
                metricValue.data.forEach((dataEntry: any) => {
                  dataEntry.metricColor = assignedColor;
                  dataEntry.metricLinearGradient = metricValue.metricLinearGradient;
                });
              }
              
              console.log(`Assigned color to metric "${extractedOption}":`, assignedColor);
            }
          });
        }
      });
    });
  }

  /**
   * Filters the color palette to remove colors that already exist in brandcolors
   * This prevents duplicate colors and ensures brand colors take precedence
   */
  filterColorPalette(): void {
    if (!this.colorPalette || !Array.isArray(this.colorPalette)) {
      this.filteredColorPalette = [];
      return;
    }

    // Extract hex codes from brandcolors
    const brandHexCodes = new Set<string>();
    if (this.brandcolors && Array.isArray(this.brandcolors)) {
      this.brandcolors.forEach((brand: any) => {
        if (brand.HexCode) {
          // Normalize hex codes to uppercase for comparison
          brandHexCodes.add(brand.HexCode.toUpperCase());
        }
      });
    }

    // Filter out colors that exist in brandcolors
    this.filteredColorPalette = this.colorPalette.filter((color: string) => {
      // Normalize color to uppercase for comparison
      const normalizedColor = color.toUpperCase();
      return !brandHexCodes.has(normalizedColor);
    });

    // If all colors were filtered out, keep the original palette as fallback
    if (this.filteredColorPalette.length === 0) {
      console.warn("All colors from palette exist in brandcolors. Using original palette as fallback.");
      this.filteredColorPalette = [...this.colorPalette];
    }

    console.log("Original color palette:", this.colorPalette);
    console.log("Brand hex codes:", Array.from(brandHexCodes));
    console.log("Filtered color palette:", this.filteredColorPalette);
  }

  /**
   * Gets a color from the filtered color palette with safe index wrapping
   */
  getFilteredColor(index: number): string {
    if (!this.filteredColorPalette || this.filteredColorPalette.length === 0) {
      // Fallback to original palette if filtered palette is empty
      return this.colorPalette && this.colorPalette.length > 0 
        ? this.colorPalette[index % this.colorPalette.length] 
        : '#000000'; // Ultimate fallback
    }
    return this.filteredColorPalette[index % this.filteredColorPalette.length];
  }

  ngOnInit(): void {
    // Filter color palette to remove colors that already exist in brandcolors
    this.filterColorPalette();
    
    // ✅ subscribe to snapshot observable
    this._insightsSerive.isSingleInsightsSnapshot$.subscribe((singleInsight)=>{
      this.singleInsight = singleInsight;
      this._cdr.detectChanges();
    });
    
    this.subscription = this._insightsSerive.isInsightsSnapshot$.subscribe(
      (snapshot) => {
        this.isInsightspopupOpen = snapshot['show'];
        if (snapshot['show'] == true) {
          try {
            // snapshot.message assumed as JSON string
            this.insightsData = JSON.parse(snapshot.message);

            this.insightKeys = Object.keys(this.insightsData);

            this.insightKeys.forEach((e: any) => {
              try {
                //child json parsing
                if (this.insightsData?.[e]?.Value.indexOf('```json') != -1) {
                  let parseData = this.insightsData[e]['Value']
                    .replace(/^```\s*/, '') // remove leading ``` (and optional newline)
                    .replace(/^json\s*/, '') // remove leading json (and optional newline)
                    .replace(/```$/, '');

                  this.insightsData[e]['Value'] = this.extractResponse(e, parseData);
                }

                this.insightsData[e]['Value'] = (this.insightsData?.[e]?.Value || '')
                  .split('\n')
                  .filter((line: any) => line.trim() !== '')
                  .map((line: any) => line.replace(/[*-]/g, '').trim());
              } catch (keyError) {
                this.insightsData[e]['Value'] = 'No Data Available';
              }
            });

            if (snapshot.message != 'loading') this.isLoading = false;
          } catch (err) {
            console.error(
              'Invalid JSON in snapshot message:',
              snapshot.message,
              err
            );
            this.insightsData = undefined;
            this.insightKeys = undefined;
            if (snapshot.message != 'loading') this.isLoading = false;
          }
        } else {
          this.insightsData = undefined;
          this.insightKeys = undefined;
        }

        if (this.isInsightspopupOpen) {
          setTimeout(() => (this.mounted = true), 0);
        } else {
          this.mounted = false;
        }
      }
    );
  } 
  private extractResponse(ekey: string, data: any): string {
    let parseData = JSON.parse(data);
    //json property parsing
    let parseDataKeys = Object.keys(parseData);
    if (parseDataKeys.length > 0) {
      let value = '';
      Object.keys(parseData).forEach((xKey: any) => {
        if (parseData && parseData[xKey]) {
          parseData[xKey] = Array.isArray(parseData[xKey])
            ? parseData[xKey].join('\n')
            : parseData[xKey];
          value += `${parseData[xKey]} \n`;
        }
      });
      this.insightsData[ekey]['Value'] =
        (value ?? '') === '' ? this.insightsData[ekey]['Value'] : value;
    } else {
      this.insightsData[ekey]['Value'] = this.insightsData[ekey]['Value'];
    }

    return this.insightsData[ekey]['Value'];
  }

  ngOnChanges(changes: SimpleChanges) {
    this.isLoading = true;
    if (changes['singleInsight']) {
      console.log(this.singleInsight);
    }
    // this.insightsData = this.insightsVal != undefined ? JSON.parse(this.insightsVal) : undefined;

    // this.insightKeys = this.insightsVal != undefined? Object.keys(this.insightsData): undefined;

    // if (this.insightsVal != undefined) {
    // this.insightKeys.forEach((e: any) => {
    // this.insightsData[e]['Value'] = (this.insightsData?.[e]?.Value || '')
    // .split('\n')
    // .filter((line: any) => line.trim() !== '')
    // .map((line: any) => line.replace(/[*-]/g, '').trim());});}

    sessionStorage.setItem('dataLoaded', 'true');
    console.log('outputData', this._configService.standardSnapOutputData);
    //Perform an operation if either pageData or widgetData changes
    if (changes['outputData']) {
      this.pageCount = this._configCustomService.pageCount;
      if (Object.keys(changes['outputData'].currentValue).length != 0) {
        this.outputDataRefresh();
      }
    }

    if (changes['sigIndex'] && this.sigIndex != 'sig') {
      if (Object.keys(this.outputData).length > 0) {
        this.outputDataRefresh();
      }
    }

    if (this.isInsightspopupOpen) {
      setTimeout(() => (this.mounted = true), 0);
    } else {
      this.mounted = false;
    }
  }

  outputDataRefresh() {
    this.loader.showLoader();
    this.hideCharts = true;
    this.data = [];
    this.gridData = [];
    this.outputPageData = [];
    // Refresh color filtering when data is refreshed
    this.filterColorPalette();
    this.handleSectionOrSubsectionChange();
  }

  outputPageData: any = [];
  datafromLayout: any = [];
  data: any = [];
  pagesConfiguredFromLayout: any;
  totalNumberOfCharts: number = 0;
  columnPerRowCount: number = 0;
  baseSelected: string = 'total base';
  showGlobalDefaultPopup: boolean = false;
  dontShowAgain: boolean = false;
  private globalDefaultPopupTimeout: any; // timeout ref for auto-dismiss
  selectedDataFormat: string = '';
  isTotalBase: boolean = false;
  selected_study: string = '';
  selected_client: string = '';
  DefaultConfidenceLevel: string = '';
  @Input() selectedWeight: string = '';

  //  chartList: {
  //   widgetName: string,
  //   image: string
  // }[] = [];
  chartList: any[] = [];

  gridTempleteColumns: string = '';
  arktabaccess: boolean = false;
  handleSectionOrSubsectionChange() {
    this.chartList = [];
    this.pageCount = this._configCustomService.pageCount; //on change of section/subsection move to page 1
    this.disableLeftClick = true;
    this.disableRightClick = false;
    this.updateNavigationButtonsState();
    let pages = [];
    for (let i = 0; i < this.outputData.pageData.length; i++) {
      pages.push({
        page: this.outputData.pageData[i].key,
        selectedLayout: this.outputData.pageData[i].value, // Default value will be `null`
        disabled: false,
        dropdownOpen: false, // Add a flag to track dropdown state
        layout: [
          { label: 'Select a layout', value: null, selected: false },
          {
            label: '6 Widget Layout',
            value: 6,
            url: '../../../../../assets/ImagesSnapshot/Public/sixWidget_inactive.png',
            activeurl:
              '../../../../../assets/ImagesSnapshot/Public/sixWidget_active.png',
            selected: this.outputData.pageData[i].value == 6 ? true : false,
          },
          {
            label: '4 Widget Layout',
            value: 4,
            url: '../../../../../assets/ImagesSnapshot/Public/fourWidget_inactive.png',
            activeurl:
              '../../../../../assets/ImagesSnapshot/Public/fourWidget_active.png',
            selected: this.outputData.pageData[i].value == 4 ? true : false,
          },
        ],
      });
    }
    this.datafromLayout = pages;

    let sum = 0;
    let count = 0;
    this.datafromLayout.forEach((val: any) => {
      if (val.selectedLayout != null) {
        sum = sum + val.selectedLayout;
        count++;
      }
    });
    console.log(sum);
    //If no. of pages configured in layout is only one then disable right pagination click
    if (count == 1) {
      this.disableRightClick = true;
    }
    //this.totalNumberOfCharts=this.snapShotService.LayoutDiv;
    this.pagesConfiguredFromLayout = count;
    this.totalNumberOfCharts = sum;
    this.columnPerRowCount = sum;

    for (let i = 0; i < this.totalNumberOfCharts; i++) {
      this.chartList.push({
        customizationProperties: '',
        metric: [],
        previewChartPostion: -1,
        widgetParentChartType: '',
        widget_name: '',
        widgetchart_name: '',
      });
    }

    //Adding widget details in chartList
    for (let i = 0; i < this.outputData.widgetData.length; i++) {
      if (this.outputData.widgetData[i].previewChartPostion == 0) {
        continue;
      }
      this.chartList[this.outputData.widgetData[i].previewChartPostion - 1] =
        this.outputData.widgetData[i];
    }
    this.hideCharts = true;

    setTimeout(() => {
      this.createInitialChartList();
      this.data = this._configService.selectedcompareacrossOption.includes(
        'Multiple'
      )
        ? this.paginatedDataMultiple()
        : this.paginatedData();

      this._configService.InsightsData = this.data;
      if (
        this.data.length == 1 &&
        this.data[0].widgetchart_name == 'FUNNEL CHART'
      ) {
        this.prepareGridForMultiFunnel(this.data[0]);
      }

      this.hideCharts = false;
      this.loader.hideLoader();
      const skipPopup =
        localStorage.getItem('dontShowGlobalDefaultPopup') === 'true';
      const alreadyShownThisSession = sessionStorage.getItem('shownGlobalDefaultPopup') === 'true';
      if (
        this._configService.isGlobalDefaultSelectionEnabled &&
        this._configService.showGlobalDefaultPopup &&
        !skipPopup &&
        !alreadyShownThisSession
      ) {
        this.showGlobalDefaultPopup = true;
  this.startGlobalDefaultPopupTimer();
        sessionStorage.setItem('shownGlobalDefaultPopup', 'true');
      }
    }, 1000);
    console.log('customData:', this.data);
  }
  createInitialChartList() {
    // ;
    // for (let i = 0; i < this.totalNumberOfCharts; i++) {
    //   this.chartList.push({
    //     widgetName: "",
    //     image: ""
    //   });
    // }
    //Based on page number assign this.columnPerRowCount
    let page = this.datafromLayout.filter((item: any) => {
      return JSON.stringify(item).includes('Page ' + this.pageCount);
    });
    if (page.length > 0) {
      this.columnPerRowCount = page[0].selectedLayout;

      this.gridTempleteColumns = '';
      for (let i = 0; i < this.columnPerRowCount / 2; i++) {
        this.gridTempleteColumns +=
          this.calculateValuePerDivision(this.columnPerRowCount / 2) + '% ';
      }
      console.log('gridTempleteColumns', this.gridTempleteColumns);
    }
  }
  calculateValuePerDivision(numDivs: any) {
    const k = 99; // considering for 2 always 27.5.So reciprocal method: 27.5=k/2=>55.
    //so now for 3 it will be 55/3 ,for 4 it will be 55/4 and so on....
    return k / numDivs;
  }
  outputdata: any; //dummy
  chartData: any;
  paginatedData() {
    this.globalColorMap = {};
    this.storeBrandColorsInGlobalColorMap();
    this.globalColorMapLinearGradient = {};
    this.globalMetricColorMap = {};
    this.globalMetricColorMapLinearGradient = {};
    this.outputdata = this._configService.standardSnapOutputData; //remove later
    //this.chartData=this._configService.standardSnapOutputData;
    //this.chartList1=this.chartList;
    let start = 0;
    if (this.pageCount == 0) {
      start = 0;
    } else {
      for (let i = 0; i < this.pageCount - 1; i++) {
        start = start + this.datafromLayout[i].selectedLayout;
      }
    }
    // const start = (this.pageCount - 1) * this.columnPerRowCount;
    const end = start + this.columnPerRowCount;
    let chartlist = this.chartList.slice(start, end);
    let pageCounter = 1;
    let item = chartlist;
    let items = _.cloneDeep(chartlist);

    items.forEach((item: any) => {
      if (item.widgetchart_name == 'Table') {
        let m = JSON.parse(item.customizationProperties);
        item.enableDataBars = m.enableDataBars;
        const props = JSON.parse(item.customizationProperties || '{}');
        props.isBarDataEnable = m.enableDataBars;
        item.customizationProperties = JSON.stringify(props);
        item.toggleButton = true;
      }
      item.metric.forEach((itemLev1: any) => {
        if (itemLev1.metric_group == '' && itemLev1.metric_value.length > 0) {
          let allMetricsNull = true;
          itemLev1.metric_value.forEach((metric: any) => {
            const outputRow = _.cloneDeep(
              this.outputdata.find(
                (row: any) =>
                  row.rowChild.includes(metric.option) &&
                  row.widgetNumber == item.widgetNumber &&
                  item.widgetName == row.widgetName
              )
            );
            //const outputRow = _.cloneDeep(this.outputdata.find((row: any) => row.rowChild.includes(metric.option) && row.colChild.includes(metric.colChild) && row.widgetNumber == item.previewChartPostion && item.widget_name == row.widgetName));
            if (
              this.baseSelected.toLowerCase() != 'total base'
                ? outputRow?.answerWeightedShare !== null
                : outputRow?.totalWeightedShare !== null
            ) {
              allMetricsNull = false;
            }
          });
          if (allMetricsNull) {
            item.metric = [];
            item.noData = true;
          }
        } else if (
          itemLev1.metric_group != '' &&
          itemLev1.metric_value.length == 0
        ) {
          let allMetricsNull = true;
          const metrics = this._configService.standardSnapOutputData.filter(
            (row: any) =>
              row.widgetNumber == item.widgetNumber &&
              item.widgetName == row.widgetName
          );
          if (metrics.length > 0) {
            metrics.forEach((metric: any, index: number) => {
              if (
                this.baseSelected.toLowerCase() != 'total base'
                  ? metric?.answerWeightedShare !== null
                  : metric?.totalWeightedShare !== null
              ) {
                allMetricsNull = false;
              }
            });
            if (allMetricsNull) {
              item.metric = [];
              item.noData = true;
            }
          }
        } else if (
          itemLev1.metric_group == '' &&
          itemLev1.metric_value.length == 0
        ) {
          item.metric = [];
        }
      });
    });

    // Store metric colors before processing data
    this.storeMetricColorsInGlobalColorMap(items);
    
    // Assign metric colors to the data items themselves
    this.assignColorsToMetricData(items);

    items.forEach((widget) => {
      if (!widget.widget_name || !widget.metric || widget.metric.length === 0)
        return;
      let globalColorIndex = 0;
      const metricValues = widget.metric[0].metric_value;
      metricValues.forEach((metricValue: any) => {
        metricValue.data = metricValue.data.map((entry: any) => {
          const colChild = entry.colChild;
          const rowChild = entry.rowChild;
          let colorKey = colChild;
      
          if (this._configService.selectedSnapshotType == 'Single Brand' || 
              this._configService.selectedSnapshotType == 'Audience Snapshot') {
            colorKey = `${colChild}__${rowChild}`;
          }

          // Assign color consistently across all widgets
          if (!this.globalColorMap[colorKey]) {
            this.globalColorMap[colorKey] = this.getFilteredColor(globalColorIndex);
            this.globalColorMapLinearGradient[colorKey] =
              this.linearGradientsColorPalette[globalColorIndex % this.linearGradientsColorPalette.length];
            globalColorIndex++;
          }

          const color = this.globalColorMap[colorKey];
          const colorLinearGradient =
            this.globalColorMapLinearGradient[colorKey];

          return {
            ...entry,
            color,
            colorLinearGradient,
          };
        });
      });
    });

    this._configCustomService.pageCount = this.pageCount;
    console.log('WidgetOutput', items);
    this._configService.paginatedItems = items;
    // publish global maps to SnapshotService so other components (charts) can consume them
    this._configService.setGlobalColorMap(this.globalColorMap);
    this._configService.setGlobalColorMapLinearGradient(this.globalColorMapLinearGradient);
    this._configService.setGlobalMetricColorMap(this.globalMetricColorMap);
    this._configService.setGlobalMetricColorMapLinearGradient(this.globalMetricColorMapLinearGradient);
    // Emit the updated globalColorMap to parent component
    this.globalColorMapChanged.emit(this.globalColorMap);
    return items;
  }

  paginatedDataMultiple() {
    this.globalColorMap = {};
    this.storeBrandColorsInGlobalColorMap();
    this.globalColorMapLinearGradient = {};
    this.globalMetricColorMap = {};
    this.globalMetricColorMapLinearGradient = {};
    this.outputdata = this._configService.standardSnapOutputData; //remove later
    let start = 0;
    if (this.pageCount == 0) {
      start = 0;
    } else {
      for (let i = 0; i < this.pageCount - 1; i++) {
        start = start + this.datafromLayout[i].selectedLayout;
      }
    }
    // const start = (this.pageCount - 1) * this.columnPerRowCount;
    const end = start + this.columnPerRowCount;
    let chartlist = this.chartList.slice(start, end);
    let pageCounter = 1;
    let item = chartlist;
    let items = _.cloneDeep(chartlist);

    items.forEach((item: any) => {
      if (item.widgetchart_name == 'Table') {
        let m = JSON.parse(item.customizationProperties);
        item.enableDataBars = m.enableDataBars;
        const props = JSON.parse(item.customizationProperties || '{}');
        props.isBarDataEnable = m.enableDataBars;
        item.customizationProperties = JSON.stringify(props);
        item.toggleButton = true;
      }

      item.metric.forEach((itemLev1: any) => {
        if (itemLev1.metric_group == '' && itemLev1.metric_value.length > 0) {
          let allMetricsNull = true;
          itemLev1.metric_value.forEach((metric: any) => {
            const outputRow = _.cloneDeep(
              this.outputdata.find(
                (row: any) =>
                  row.rowChild.includes(metric.option) &&
                  row.colChild.includes(metric.colChild) &&
                  row.widgetNumber == item.previewChartPostion &&
                  item.widget_name == row.widgetName
              )
            );
            if (
              this.baseSelected.toLowerCase() != 'total base'
                ? outputRow?.answerWeightedShare !== null
                : outputRow?.totalWeightedShare !== null
            ) {
              allMetricsNull = false;
            }
          });
          if (allMetricsNull) {
            item.metric = [];
            item.noData = true;
          }
        } else if (
          itemLev1.metric_group != '' &&
          itemLev1.metric_value.length == 0
        ) {
          let allMetricsNull = true;
          const metrics = this._configService.standardSnapOutputData.filter(
            (row: any) =>
              row.widgetNumber == item.widgetNumber &&
              item.widgetName == row.widgetName
          );
          if (metrics.length > 0) {
            metrics.forEach((metric: any, index: number) => {
              if (
                this.baseSelected.toLowerCase() != 'total base'
                  ? metric?.answerWeightedShare !== null
                  : metric?.totalWeightedShare !== null
              ) {
                allMetricsNull = false;
              }
            });
            if (allMetricsNull) {
              item.metric = [];
              item.noData = true;
            }
          }
        } else if (
          itemLev1.metric_group == '' &&
          itemLev1.metric_value.length == 0
        ) {
          item.metric = [];
        }
      });
    });
    this._configCustomService.pageCount = this.pageCount;

    // Store metric colors before processing data
    this.storeMetricColorsInGlobalColorMap(items);
    
    // Assign metric colors to the data items themselves
    this.assignColorsToMetricData(items);

    items.forEach((widget) => {
      if (!widget.widget_name || !widget.metric || widget.metric.length === 0)
        return;
      let globalColorIndex = 0;
      const metricValues = widget.metric[0].metric_value;

      metricValues.forEach((metricValue: any) => {
        metricValue.data = metricValue.data.map((entry: any) => {
          const colChild = entry.colChild;
          const rowChild = entry.rowChild;
          let colorKey = colChild;
          if (this._configService.selectedSnapshotType == 'Single Brand' || 
               this._configService.selectedSnapshotType == 'Audience Snapshot') {
            colorKey = `${colChild}__${rowChild}`;
          }

          // Assign color consistently across all widgets
          if (!this.globalColorMap[colorKey]) {
            this.globalColorMap[colorKey] = this.getFilteredColor(globalColorIndex);
            this.globalColorMapLinearGradient[colorKey] =
              this.linearGradientsColorPalette[globalColorIndex % this.linearGradientsColorPalette.length];
            globalColorIndex++;
          }

          const color = this.globalColorMap[colorKey];
          const colorLinearGradient =
            this.globalColorMapLinearGradient[colorKey];

          return {
            ...entry,
            color,
            colorLinearGradient,
          };
        });
      });
    });
    
    // publish global maps to SnapshotService so other components (charts) can consume them
    this._configService.setGlobalColorMap(this.globalColorMap);
    this._configService.setGlobalColorMapLinearGradient(this.globalColorMapLinearGradient);
    this._configService.setGlobalMetricColorMap(this.globalMetricColorMap);
    this._configService.setGlobalMetricColorMapLinearGradient(this.globalMetricColorMapLinearGradient);
    
    console.log('WidgetOutput', items);
     this._configService.allPageOutputData=items;
    // Emit the updated globalColorMap to parent component
    this.globalColorMapChanged.emit(this.globalColorMap);
    return items;
  }

  updateDataBars(item: any, status: boolean) {
    item.enableDataBars = status;
    const props = JSON.parse(item.customizationProperties || '{}');
    props.enableDataBars = status;
    item.customizationProperties = JSON.stringify(props);
    item.toggleButton = false;
    setTimeout(() => (item.toggleButton = true));
  }

  //----------Handling pagination counter---------
  pageCount = 1;
  disableLeftClick = false;
  disableRightClick = false;
  Paginate(side: string) {
    if (side == 'left') {
      const newPageData = { page: this.pageCount, data: this.data }; // Replace with your page and data
      const pageIndex = this.outputPageData.findIndex(
        (item: any) => item.page === newPageData.page
      );
      if (pageIndex !== -1) {
        // Page exists, update the data
        this.outputPageData[pageIndex].data = newPageData.data;
      } else {
        // Page does not exist, append the new entry
        this.outputPageData.push(newPageData);
      }
      if (this.pageCount == 2) {
        this.pageCount--;
        this.createInitialChartList();
        // this.data = this._configService.selectedcompareacrossOption.includes("Multiple") ? this.paginatedDataMultiple() : this.paginatedData();
        let isPage = this.outputPageData.findIndex(
          (item: any) => item.page === this.pageCount
        );
        if (isPage == -1) {
          this.data = this._configService.selectedcompareacrossOption.includes(
            'Multiple'
          )
            ? this.paginatedDataMultiple()
            : this.paginatedData();
        } else {
          this.data = this.outputPageData[isPage].data;
        }
        this.disableLeftClick = true;
        this.disableRightClick = false;
      } else {
        this.disableLeftClick = false;
        this.disableRightClick = false;
        this.pageCount--;
        this.createInitialChartList();
        // this.data = this._configService.selectedcompareacrossOption.includes("Multiple") ? this.paginatedDataMultiple() : this.paginatedData();
        let isPage = this.outputPageData.findIndex(
          (item: any) => item.page === this.pageCount
        );
        if (isPage == -1) {
          this.data = this._configService.selectedcompareacrossOption.includes(
            'Multiple'
          )
            ? this.paginatedDataMultiple()
            : this.paginatedData();
        } else {
          this.data = this.outputPageData[isPage].data;
        }
      }
    } else if (side == 'right') {
      // if (this.pageCount == (Math.ceil(this.totalNumberOfCharts / this.columnPerRowCount) - 1)) {
      const newPageData = { page: this.pageCount, data: this.data }; // Replace with your page and data
      const pageIndex = this.outputPageData.findIndex(
        (item: any) => item.page === newPageData.page
      );
      if (pageIndex !== -1) {
        // Page exists, update the data
        this.outputPageData[pageIndex].data = newPageData.data;
      } else {
        // Page does not exist, append the new entry
        this.outputPageData.push(newPageData);
      }
      if (this.pageCount == this.pagesConfiguredFromLayout - 1) {
        this.pageCount++;
        this.createInitialChartList();
        this.disableRightClick = true;
        let isPage = this.outputPageData.findIndex(
          (item: any) => item.page === this.pageCount
        );
        if (isPage == -1) {
          this.data = this._configService.selectedcompareacrossOption.includes(
            'Multiple'
          )
            ? this.paginatedDataMultiple()
            : this.paginatedData();
        } else {
          this.data = this.outputPageData[isPage].data;
        }
        this.disableLeftClick = false;
      } else {
        this.pageCount++;
        this.createInitialChartList();
        this.disableLeftClick = false;
        this.disableRightClick = false;
        // this.data = this._configService.selectedcompareacrossOption.includes("Multiple") ? this.paginatedDataMultiple() : this.paginatedData();
        let isPage = this.outputPageData.findIndex(
          (item: any) => item.page === this.pageCount
        );
        if (isPage == -1) {
          this.data = this._configService.selectedcompareacrossOption.includes(
            'Multiple'
          )
            ? this.paginatedDataMultiple()
            : this.paginatedData();
        } else {
          this.data = this.outputPageData[isPage].data;
        }
      }
    }

    this.pageCounterChanged.emit(this.pageCount);
    //console.log("New" + this.data);
    if (
      this.data.length == 1 &&
      this.data[0].widgetchart_name == 'FUNNEL CHART'
    ) {
      this.prepareGridForMultiFunnel(this.data[0]);
    }
    return;
  }

  updateNavigationButtonsState() {
    // Enable/disable navigation buttons based on pageCount
    this.disableLeftClick = this.pageCount <= 1; // Disable left if on the first page
    this.disableRightClick = this.pageCount >= this.pagesConfiguredFromLayout; // Disable right if on the last page
  }

  // elementClickedStatus(event: any) {
  //   const updatedData = this.data.map((d: any) => {
  //     if (d == event.data) {
  //       if (event.key == "sort") {
  //         if(event.value=="ascending"){
  //           d.metric.forEach((dd:any)=>{
  //             dd.metric_value[0].data.sort((a:any, b:any) => a.data - b.data);
  //           })
  //         }
  //       }
  //       else {
  //         let m = JSON.parse(d.customizationProperties);
  //         m[event.key] = event.value;
  //         return {
  //           ...d,
  //           customizationProperties: JSON.stringify(m),
  //         };
  //       }
  //     }
  //     return d;
  //   });
  //   this.data = [...updatedData];
  // }

  originalData: any[] = [..._.cloneDeep(this.data)]; // Initialize with the original data

  elementClickedStatus(event: any) {
    console.log(event);
    const updatedData = this.data.map((d: any) => {
      if (d === event.data) {
        if (event.key === 'sort' && d.widgetchart_name != 'Table') {
          const customizationProps = JSON.parse(
            d.customizationProperties || '{}'
          );
          customizationProps[event.key] = event.value;
          if (event.value === 'ascending' || event.value === 'descending') {
            if (
              this._configService.selectedSnapshotType
                .toLowerCase()
                .includes('multi')
            ) {
              return {
                ...d,
                customizationProperties: JSON.stringify(customizationProps),
                metric: d.metric.map((dd: any) => ({
                  ...dd,
                  metric_value: dd.metric_value.map((mv: any) => ({
                    ...mv,
                    data: [...mv.data].sort((a: any, b: any) =>
                      event.value === 'ascending'
                        ? a.data - b.data
                        : b.data - a.data
                    ),
                  })),
                })),
              };
            } else {
              console.log(d);

              return {
                ...d,
                customizationProperties: JSON.stringify(customizationProps),
                metric: d.metric.map((dd: any) => {
                  // Sort the metric_value items based on the first item in the data array
                  const sortedMetricValue = [...dd.metric_value].sort(
                    (a: any, b: any) => {
                      const aData = a.data[0]?.data; // Access the 'data' key of the first item in the data array
                      const bData = b.data[0]?.data; // Same for b

                      // Check if both aData and bData exist and compare them, else default to 0
                      if (aData !== undefined && bData !== undefined) {
                        return event.value === 'ascending'
                          ? aData - bData
                          : bData - aData; // Ascending order based on the 'data' value
                      }
                      return 0; // Default to no sort if comparison cannot be made
                    }
                  );

                  return {
                    ...dd,
                    metric_value: sortedMetricValue, // Set the sorted metric_value array
                  };
                }),
              };
            }
          } else if (event.value === 'default') {
            // Restore the original data for this specific item
            return {
              ...d,
              customizationProperties: JSON.stringify(customizationProps),
              metric: d.metric.map((dd: any) => ({
                ...dd,
                metric_value: dd.metric_value.map((mv: any) => ({
                  ...mv,
                  data: [...mv.data].sort(
                    (a: any, b: any) => a.defaultIndex - b.defaultIndex
                  ), // Sort by 'defaultIndex'
                })),
              })),
            };
          }
        } else {
          // Handle customizationProperties updates
          const customizationProps = JSON.parse(
            d.customizationProperties || '{}'
          );
          customizationProps[event.key] = event.value;
          console.log(customizationProps);
          return {
            ...d,
            customizationProperties: JSON.stringify(customizationProps),
          };
        }
      }
      return d;
    });
    let globalColorIndex: number = Object.keys(this.globalColorMap).length - 1;
    updatedData.forEach((widget: any) => {
      if (!widget.widget_name || !widget.metric || widget.metric.length === 0)
        return;

      const metricValues = widget.metric[0].metric_value;

      metricValues.forEach((metricValue: any) => {
        metricValue.data = metricValue.data.map((entry: any) => {
          const colChild = entry.colChild;
          const rowChild = entry.rowChild;
          let colorKey = colChild;
          if (this._configService.selectedSnapshotType == 'Single Brand' || 
               this._configService.selectedSnapshotType == 'Audience Snapshot') {
            colorKey = `${colChild}__${rowChild}`;
          }

          // Assign color if not already mapped
          if (!this.globalColorMap[colorKey]) {
            this.globalColorMap[colorKey] = this.getFilteredColor(globalColorIndex);
            this.globalColorMapLinearGradient[colorKey] =
              this.linearGradientsColorPalette[globalColorIndex % this.linearGradientsColorPalette.length];
            globalColorIndex++;
          }
          const color = this.globalColorMap[colorKey];
          const colorLinearGradient =
            this.globalColorMapLinearGradient[colorKey];
          return {
            ...entry,
            color,
            colorLinearGradient,
          };
        });
      });
    });
    
    // Update metric color maps after element click
    this.storeMetricColorsInGlobalColorMap(updatedData);
    
    // Assign metric colors to the data items themselves
    this.assignColorsToMetricData(updatedData);
    
    // Publish updated maps to SnapshotService
    this._configService.setGlobalColorMap(this.globalColorMap);
    this._configService.setGlobalColorMapLinearGradient(this.globalColorMapLinearGradient);
    this._configService.setGlobalMetricColorMap(this.globalMetricColorMap);
    this._configService.setGlobalMetricColorMapLinearGradient(this.globalMetricColorMapLinearGradient);
    
    this.data = [...updatedData];
    this._configService.newCustomizationData = this.data;
  }

  gridData: any[] = [];
  prepareGridForMultiFunnel(customData: any) {
    customData.metric[0].metric_value[0].data.forEach((d: any) => {
      // this.brandList.push(d.colChild);
      this.gridData.push({
        header: d.colChild,
        data: customData,
      });
    });
  }

  OnInsigthsbuttonClick() {
    this.arktabaccess = true;
    let data = [];
    this.InsightsResponse = [];
    let ShareColumn =
      this.selectedDataFormat != 'Respondent Level'
        ? 'value'
        : this.isTotalBase
        ? this.selectedWeight == 'Unweighted'
          ? 'totalUnweightedShare'
          : 'totalWeightedShare'
        : this.selectedWeight == 'Unweighted'
        ? 'answerUnweightedShare'
        : 'answerWeightedShare';
    let BaseColumn = this.isTotalBase
      ? 'totalUnweightedBase'
      : 'answerUnweightedBase';
    this.apiService
      .getInsightsData(
        this.isIndex,
        this.outputData,
        this.selected_study,
        this.selected_client,
        this.inforRibbon?.nativeElement.textContent,
        this.DefaultConfidenceLevel,
        ShareColumn,
        BaseColumn
      )
      .subscribe((result: string) => {
        // Response is valid
        // this.errorPopup(result, "Insights for the Generated Ouptput data")
        // let insightsData = JSON.parse(result.Data);
        // this.InsightsData = insightsData;
        this.isInsightspopupOpen = true;
        this.showSnapshot = true;
        // const insightsObj: InsightsModel = {
        //   header: 'Insights',
        //   message: result,
        //   show: true,
        // };
        const insightData = result
          .split('- ')
          .map((item) => item.trim())
          .filter((item) => item.length > 0);
        this.insightsVal = insightData;
        //console.log(this.insightsVal);
        // Show the alert popup using the alert service
        this._insightsSerive.showInisghts(this.InsightsResponse);
        //hide the loader
        this.arktabaccess = false;
      });
  }

  closeGlobalDefaultPopup() {
    if (this.dontShowAgain) {
      localStorage.setItem('dontShowGlobalDefaultPopup', 'true');
    }
    this.showGlobalDefaultPopup = false;
    if (this.globalDefaultPopupTimeout) {
      clearTimeout(this.globalDefaultPopupTimeout);
      this.globalDefaultPopupTimeout = null;
    }
  }

  onChartScroll(event: WheelEvent, index: number) {
    const target = event.target as HTMLElement;
    const insightContainer = document.getElementById(`insight-${index}`);

    if (!insightContainer) return;

    // Detect which container the scroll event originated from
    const scrollContainer = this.getScrollContainer(target);

    // Detect scroll direction
    const scrollDirection = this.getScrollDirection(event.deltaY);

    // Find if there's any scrollable element within the chart container
    const scrollableElement = this.findScrollableElement(target);
    const hasChartScrollableContent = scrollableElement !== null;
    const hasTextScrollableContent = this.hasScrollableContent(insightContainer);

    // Scenario 4: If scroll is neither on chart or text container, enable default browser scroll
    if (scrollContainer === 'unknown') {
      return; // Enable default browser scroll
    }

    // Scenarios for CHART CONTAINER scrolling
    if (scrollContainer === 'chart') {
      if (hasChartScrollableContent) {
        const isChartAtLimit = this.isAtScrollLimit(scrollableElement, event.deltaY);

        if (scrollDirection === 'down' && isChartAtLimit) {
          // Scenario 1: Chart scrolling down and reached bottom limit
          if (hasTextScrollableContent) {
            const isTextAtBottomLimit = this.isAtScrollLimit(insightContainer, event.deltaY);
            if (isTextAtBottomLimit) {
              // Text also at bottom limit, enable browser scroll down
              return;
            } else {
              // Text can scroll down, scroll the text container
              event.preventDefault();
              event.stopPropagation();
              this.smoothScrollInsight(insightContainer, event.deltaY);
            }
          } else {
            // No text scrollable content, enable browser scroll down
            return;
          }
        } else if (scrollDirection === 'up' && isChartAtLimit) {
          // Scenario 3: Chart scrolling up and reached top limit
          // Enable browser scroll up regardless of text container state
          return;
        } else {
          // Chart can still scroll
          event.preventDefault();
          event.stopPropagation();
          scrollableElement.scrollTop += event.deltaY * 0.005;
        }
      } else {
        // No chart scrollable content, check text container
        if (hasTextScrollableContent) {
          const isTextAtLimit = this.isAtScrollLimit(insightContainer, event.deltaY);
          if (isTextAtLimit) {
            // Text at limit, enable browser scroll
            return;
          } else {
            // Text can scroll
            event.preventDefault();
            event.stopPropagation();
            this.smoothScrollInsight(insightContainer, event.deltaY);
          }
        } else {
          // No scrollable content in either, enable browser scroll
          return;
        }
      }
    }

    // Scenarios for TEXT CONTAINER scrolling
    else if (scrollContainer === 'text') {
      if (hasTextScrollableContent) {
        const isTextAtLimit = this.isAtScrollLimit(insightContainer, event.deltaY);

        if (scrollDirection === 'down' && isTextAtLimit) {
          // Scenario 5: Text scrolling down and reached bottom limit
          if (!hasChartScrollableContent) {
            // No chart scrollable content, enable browser scroll down
            return;
          } else {
            // Chart has scrollable content, but text reached bottom - enable browser scroll
            return;
          }
        } else if (scrollDirection === 'up' && isTextAtLimit) {
          // Scenario 6: Text scrolling up and reached top limit
          if (hasChartScrollableContent) {
            // Check if chart is at top limit
            const isChartAtTopLimit = this.isAtScrollLimit(scrollableElement, -1); // Check for up direction
            if (isChartAtTopLimit) {
              // Chart also at top limit, enable browser scroll up
              return;
            } else {
              // Chart can scroll up, scroll the chart container
              event.preventDefault();
              event.stopPropagation();
              scrollableElement.scrollTop += event.deltaY * 0.3;
            }
          } else {
            // No chart scrollable content, enable browser scroll up
            return;
          }
        } else {
          // Text can still scroll
          event.preventDefault();
          event.stopPropagation();
          this.smoothScrollInsight(insightContainer, event.deltaY);
        }
      } else {
        // No text scrollable content, enable browser scroll
        return;
      }
    }
  }

  private getDetailedScrollInfo(target: HTMLElement): {
    container: 'chart' | 'text' | 'unknown';
    elementType: string;
    className: string;
  } {
    const container = this.getScrollContainer(target);

    return {
      container: container,
      elementType: target.tagName.toLowerCase(),
      className: target.className || 'no-class'
    };
  }

  private getScrollContainer(target: HTMLElement): 'chart' | 'text' | 'unknown' {
    // Check if the target element or its parents are within chart container
    const chartContainer = target.closest('.chart') || target.closest('.chart_expand');
    if (chartContainer) {
      return 'chart';
    }

    // Check if the target element or its parents are within text container (insight)
    const textContainer = target.closest('.insight');
    if (textContainer) {
      return 'text';
    }

    return 'unknown';
  }

  private getScrollDirection(deltaY: number): 'up' | 'down' | 'none' {
    if (deltaY > 0) {
      return 'down'; // Scrolling down
    } else if (deltaY < 0) {
      return 'up'; // Scrolling up
    } else {
      return 'none'; // No scroll
    }
  }

  private hasScrollableContent(element: HTMLElement): boolean {
    // Check if element has scrollable content (content height > visible height)
    return element.scrollHeight > element.clientHeight;
  }

  private findScrollableElement(target: HTMLElement): HTMLElement | null {
    // Look for scrollable elements in the chart container hierarchy
    let element = target;

    while (element) {
      if (this.hasScrollableContent(element)) {
        return element;
      }

      // Check parent elements up to chart container
      if (element.closest('.chart') || element.closest('.chart_expand')) {
        element = element.parentElement as HTMLElement;
        if (!element) break;
      } else {
        break;
      }
    }

    return null;
  }

  private isAtScrollLimit(element: HTMLElement, deltaY: number): boolean {
    // Check if element has scrollable content first
    if (element.scrollHeight <= element.clientHeight) {
      // No scrollable content, consider it always at limit
      return true;
    }

    const tolerance = 3; // Small tolerance for better detection

    if (deltaY > 0) {
      // Scrolling down - check if at bottom
      const scrollTop = Math.round(element.scrollTop);
      const clientHeight = Math.round(element.clientHeight);
      const scrollHeight = Math.round(element.scrollHeight);
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - tolerance;
      return isAtBottom;
    } else if (deltaY < 0) {
      // Scrolling up - check if at top (start)
      const scrollTop = Math.round(element.scrollTop);
      const isAtTop = scrollTop <= tolerance;
      return isAtTop;
    }

    return false; // No scroll direction detected
  }

  private smoothScrollInsight(insightContainer: HTMLElement, deltaY: number) {
    // Calculate scroll amount (improved sensitivity for better user experience)
    const scrollAmount = deltaY * 0.3; // Better balance between smooth and responsive

    // Apply scroll with bounds checking
    const currentScrollTop = insightContainer.scrollTop;
    const maxScrollTop = insightContainer.scrollHeight - insightContainer.clientHeight;

    const newScrollTop = Math.max(0, Math.min(currentScrollTop + scrollAmount, maxScrollTop));

    insightContainer.scrollTop = newScrollTop;
  }

  private startGlobalDefaultPopupTimer() {
    // Clear any existing timer
    if (this.globalDefaultPopupTimeout) {
      clearTimeout(this.globalDefaultPopupTimeout);
    }
    this.globalDefaultPopupTimeout = setTimeout(() => {
      // Auto-dismiss only if still visible
      if (this.showGlobalDefaultPopup) {
        this.showGlobalDefaultPopup = false;
        this._cdr.detectChanges();
      }
      this.globalDefaultPopupTimeout = null;
    }, 7000); // 7 seconds
  }

  ngOnDestroy(): void {
    if (this.globalDefaultPopupTimeout) {
      clearTimeout(this.globalDefaultPopupTimeout);
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
 getSelectedBrandLabel(item: any): string {
  // If audience is NOT null, return empty string
  if (item?.audience != null ) {
    return '';
  }

  const value =
    this._configService?.finalLeftPanelSubmitObject?.previewData
      ?.Audiencebrand?.[0]?.option;

  if (!value) {
    return '';
  }
  const rawBrandName = value.split('|').pop() ?? value;
  const brandName = `(${rawBrandName})`;
  return brandName;
}

}
